import { Component, Inject, Vue } from "vue-property-decorator";
import {
  ICProdProvider,
  ICProdProviderMethods
} from "@/models/providers/contractProduct";
import { DataModules } from "@/store/modules/data";
import { IRoute } from "@/models/routes";

@Component
export default class CProdInjectorMixin extends Vue {
  // Inject

  @Inject({ from: "contractProductProvider" })
  private readonly $cProdData!: () => ICProdProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: ICProdProviderMethods;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  // Methods

  public routeToOverview() {
    // $nextTick stops ValidationObserver error
    this.$nextTick(() =>
      this.$router
        .replace(
          (this.$store.getters[
            `data/${DataModules.CONTRACTS_PRODUCTS}/routeToOverview`
          ](this.cProdData.contractProduct, {
            doBusReload: false
          }) as IRoute).to
        )
        .catch(err => err)
    );
  }
}
